import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IndexedDBInterface } from './interface/indexedDB.interface';
import { environment } from 'src/environments/environment';
import { objectStoreName } from './common/objectStoreName';

@Injectable({
  providedIn: 'root',
})
export class DepositProductIndexedDBService implements IndexedDBInterface {
  objectStoreName = objectStoreName.depositProductStoreName;
  dbName = environment.indexDBName;

  constructor() {}

  storeDataInIndexedDB(Products: { id: number; name: string }[]): void {
    const dbRequest = indexedDB.open(this.dbName);

    dbRequest.onsuccess = (event: any) => {
      const db = event.target.result;
      const transaction = db.transaction(this.objectStoreName, 'readwrite');
      const objectStore = transaction.objectStore(this.objectStoreName);

      // replace, don't merge: products deleted or renamed on the server must not linger in the cache
      objectStore.clear();
      Products.forEach((product) => {
        objectStore.put(product);
      });

      transaction.oncomplete = () => {
        // console.log('Deposit Products stored successfully');
      };

      transaction.onerror = (event) => {
        // console.error('Error storing Deposit Products:', event.target.error);
      };
    };
  }

  getStoredData(): Observable<{ id: number; name: string }[]> {
    const dbRequest = indexedDB.open(this.dbName);

    return new Observable((observer) => {
      dbRequest.onsuccess = (event: any) => {
        const db = event.target.result;
        const transaction = db.transaction(this.objectStoreName, 'readonly');
        const objectStore = transaction.objectStore(this.objectStoreName);
        const request = objectStore.getAll();

        request.onsuccess = (event) => {
          const products = (event.target.result as {
            id: number;
            name: string;
          }[]).sort((productA, productB) => productA.name.localeCompare(productB.name));
          observer.next(products);
          observer.complete();
        };

        request.onerror = (event) => {
          console.error(
            'Error retrieving Deposit Products:',
            event.target.error
          );
          observer.error(event.target.error);
        };
      };

      dbRequest.onerror = (event: any) => {
        console.error('Error opening database:', event.target.error);
        observer.error(event.target.error);
      };
    });
  }
}
